import { combineEpics } from 'redux-observable'
import { FetchNextEpic } from './FetchNextEpic.js'
import { FetchInitialEpic } from './FetchInitialEpic.js'

export const otuEpics = combineEpics(FetchNextEpic, FetchInitialEpic)
